import { Box, CircularProgress } from "@mui/material";

const Loader = () => {
  return (
    <Box
      sx={{
        display: "grid",
        placeItems: "center",
        height: "100%",
        width: "100%",
        background: "transparent",
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  );
};

export default Loader;
